module.exports = __webpack_public_path__ + "static/media/gi.e829d66e.svg";